/* eslint-disable */
import { Component, HostBinding, OnInit } from '@angular/core';
import { AlertController, ModalController, NavController } from '@ionic/angular';
import { CONSTANTS } from 'src/app/services/config.service';
import { LoggerService } from 'src/app/services/logger.service';
import { NavigationService } from 'src/app/services/navigation/navigation.service';
import { PersonsService } from 'src/app/services/persons.service';
import { PrefsService } from 'src/app/services/prefs.service';
import { restoreFocusOnDismissModal } from 'src/app/utils/overlay-controller.utils';
import { FeedbackPage } from '../feedback/feedback.page';
import { HowToPage } from '../how-to/how-to.page';
import { MenuTermsPage } from '../menu-terms/menu-terms.page';
import { MSRemoteLoggerCategory } from 'src/app/adapters/remote-logger/utils/remote-logger.utils';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.page.html',
  styleUrls: ['./menu.page.scss']
})
export class MenuPage implements OnInit {
  @HostBinding('attr.aria-hidden') ariaHidden = false;

  translationData: any;
  rosterViewType: string;
  rosterViewTypeOptions: any;
  mapType: any;
  isDevice = CONSTANTS.IS_DEVICE;
  devTaps = 0;
  showError = false;

  constructor(
    public navCtrl: NavController,
    private nav: NavigationService,
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    private logger: LoggerService,
    private prefs: PrefsService,
    private persons: PersonsService
  ) {}

  async presentModal(page) {
    this.ariaHidden = true;

    const pageMap = { feedback: FeedbackPage, howTo: HowToPage, terms: MenuTermsPage };
    const modal = await this.modalCtrl.create({
      component: pageMap[page],
    });
    await modal.present();
    restoreFocusOnDismissModal(modal);
    modal.onDidDismiss().then(() => {
      this.ariaHidden = false;
    });
  }

  onClickLog() {
    // this.router.navigateByUrl('log')
    // this.navCtrl.push('LogPage');
    // this.viewCtrl.dismiss();
  }

  async presentAlertPasswordInvalid() {
    const alert = await this.alertCtrl.create({
      header: 'Password invalid',
      buttons: ['Dismiss']
    });
    await alert.present();
  }

  async presentAlertPromptAdd() {
    const alert = await this.alertCtrl.create({
      header: 'Login',
      inputs: [
        {
          name: 'password',
          placeholder: 'Password',
          type: 'password'
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: (data) => {
            // console.log('Cancel clicked');
            this.devTaps = 0;
          }
        },
        {
          text: 'Login',
          handler: (data) => {
            if (data.password === 'dev') {
              // logged in!
              this.devTaps = 0;
              alert
                .dismiss()
                .then(() => this.modalCtrl.dismiss())
                .then(() => {
                  this.nav.nav(['/log']);
                  // this.navCtrl.navigateRoot('/log');
                });

              return false;
            } else {
              // invalid login
              this.presentAlertPasswordInvalid();
              return false;
            }
          }
        }
      ]
    });
    await alert.present();
  }

  onClickMetadata() {
    if (++this.devTaps >= 7) {
      // TODO maybe config for lower in dev envs?
      this.presentAlertPromptAdd();
    }
  }

  dismiss() {
    const useJsMaps = this.mapType === 'JAVASCRIPT';
    //this.maps.updateUseJsMaps(useJsMaps);
    this.modalCtrl.dismiss({ rosterViewType: this.rosterViewType });
  }

  init() {
    this.logger.log('ionViewDidLoad MenuPage', MSRemoteLoggerCategory.ROSTER_MENU_PAGE);
    // this.rosterViewType = this.navParams.data.rosterViewType;
    this.rosterViewTypeOptions = ['timeline', 'list'];

    Promise.all([this.prefs.getPromises('appVersion', 'authCode', 'useJsMaps'), this.persons.getDeviceOwner()]).then((results) => {
      this.translationData = {
        appVersion: results[0][0],
        authCode: results[0][1],
        userName: results[1].name
      };
      this.mapType = results[0][2] === true ? 'JAVASCRIPT' : 'NATIVE';
    });
  }

  ionViewWillEnter() {
    this.init();
  }

  ngOnInit() {}
}
